import React from "react";

// Components
import { InlineInfoIcon } from "../../../../assets/img/icons";
import AlertBanner from "../../../../components/base/AlertBanner";

const ProspectAccountToggle = props => {
  const { setProspectToggleValues } = props;
  return (
    <>
      <AlertBanner
        icon={<InlineInfoIcon />}
        buttonLabel=" Check Prospect account in Salesforce"
        buttonOnClick={() => {
          setProspectToggleValues({
            isNoAccountFoundModalOpen: true,
            isNoAccountFoundNotification: true,
            accountType: "Account (Prospect)"
          });
        }}
        removeOnClick={() => {
          setProspectToggleValues({
            isNoAccountFoundNotification: false
          });
        }}
        message="Prospect Account was not found. Do a check for partial matches."
      />
    </>
  );
};

export default ProspectAccountToggle;
